import React from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from "react-helmet-async";

function Product() {
  const navigate = useNavigate();
  return (
    <>
    <Helmet>
        <title>
          Electrical Products & Cable Management Solutions UAE | Al Ibtekar
        </title>

        <meta
          name="description"
          content="Explore electrical products and cable management solutions from Al Ibtekar UAE, including junction boxes, enclosures, cable accessories, cable termination tools, cable management systems, cables and industrial electrical supplies."
        />

        <meta
          name="keywords"
          content="electrical products UAE, cable management products UAE, junction boxes UAE, electrical enclosures UAE, cable accessories UAE, cable glands UAE, cable termination tools UAE, cable management systems UAE, industrial cables UAE, instrumentation cables UAE, oil and gas electrical products UAE"
        />

        <link
          rel="canonical"
          href="https://saig.me/product"
        />

        <meta
          property="og:title"
          content="Electrical Products & Cable Management Solutions UAE | Al Ibtekar"
        />

        <meta
          property="og:description"
          content="Browse Al Ibtekar's range of junction boxes, electrical enclosures, cable accessories, cable termination tools, cable management systems, cables and oil & gas electrical products in the UAE."
        />

        <meta
          property="og:url"
          content="https://saig.me/product"
        />

        <meta
          property="og:type"
          content="website"
        />

        <meta
          property="og:site_name"
          content="Al Ibtekar"
        />

        <meta
          name="twitter:card"
          content="summary_large_image"
        />

        <meta
          name="twitter:title"
          content="Electrical Products & Cable Management Solutions UAE | Al Ibtekar"
        />

        <meta
          name="twitter:description"
          content="Shop electrical and cable management products including junction boxes, cable accessories, termination tools, cable systems and industrial electrical supplies from Al Ibtekar UAE."
        />
      </Helmet>

      <div className='newbanner-about newbanner-about5'>
        <div className="max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]">
          <h6 className="font-[500] font-kanit lg:text-[60px] text-[30px] lg:leading-[90px] leading-[40px] text-[#FFFFFF] lg:pb-[14px] pb-[4px]">Our Products</h6>
          <p className="lg:max-w-[582px] max-w-[250px] w-full font-[300] font-inter lg:text-[20px] text-[12px] lg:leading-[30px] leading-[16px] text-[#FFFFFF]">Welcome to our Shop! Here, you'll find a wide range of high-quality electrical products and supplies to meet all your needs.
          </p>
        </div>
      </div>
      {/* <div className="mt-[91px] overflow-hidden relative">
                <img src="/assets/product/bg1.png" className='w- lg:h-auto h-[300px] object-cover' alt="	Trusted cable management and termination solutions provider in the UAE" />
                <div className="absolute lg:top-[125px] top-[20px] max-w-[1440px] w-full mx-auto left-1/2 -translate-x-1/2 lg:px-[50px] px-[20px]">
                    <h6 className="font-[500] font-kanit lg:text-[70px] text-[30px] lg:leading-[90px] leading-[40px] text-[#FFFFFF] lg:pb-[14px] pb-[4px]">Our Products</h6>
                    <p className="max-w-[582px] w-full font-[300] font-inter lg:text-[20px] text-[14px] lg:leading-[30px] leading-[20px] text-[#FFFFFF]">Welcome to our Shop! Here, you'll find a wide range of high-quality electrical products and supplies to meet all your needs.</p>
                </div>
                <h1 className='absolute font-[600] font-kanit lg:text-[180px] text-[60px] lg:leading-[180px] leading-[70px] text-[#FFFFFF4F] right-[0px] lg:bottom-[86px] bottom-[40px]'>Product</h1>
            </div> */}
      <div className='bg-[#FFFFFF] font-kanit'>
        <div className="max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]">
<div className="product-cards-wrapper">

  <div className='grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 lg:gap-[50px] gap-[30px] pb-[100px] items-stretch'>

    <Link to='/product-detail'>
      <div className='product-card'>
        <img src="/assets/saigj1.png" alt="Trusted cable management and termination solutions provider in the UAE" />
        <div className='text-product'>
          <div>
            <h6>Junction Box & Enclosures</h6>
            <p>Enclosure, Junction Box, Terminal Strips & Blocks, Wiring & Installation</p>
          </div>
        </div>
      </div>
    </Link>

    <Link to='/ipconnectors'>
      <div className='product-card'>
        <img src="/assets/saigip1.png" alt="" />
        <div className='text-product'>
          <div>
            <h6>IP68 Re-enterable Gel & Connectors</h6>
            <p>Gel, Resin, Gel-filled Connectors, In-line & Branch Connectors</p>
          </div>
        </div>
      </div>
    </Link>


<Link to='/GlandsAccessories'>
      <div className='product-card'>
        <img src="/assets/saigacc.png" alt="" />
        <div className='text-product'>
          <div>
            <h6>Cable Accessories</h6>
            <p>Cable Glands, Multi Cable Transit System, Cable Sleeves, Cable Ties, Cable Cleats, Cable Joints, Heat Shrinks & Cable Identification</p>
          </div>
        </div>
      </div>
    </Link>

<Link to='/TerminationTools'>
      <div className='product-card'>
        <img src="/assets/saigter.png" alt="" />
        <div className='text-product'>
          <div>
            <h6>Cable Termination & Tools</h6>
            <p>Cable Lugs, Terminals, Mechanical, Manual, Battery & Hydraulic Operated Tools</p>
          </div>
        </div>
      </div>
    </Link>

<Link to='/CableManagementSystem'>
      <div className='product-card'>
        <img src="/assets/saigcable.png" alt="" />
        <div className='text-product'>
          <div>
            <h6>Cable Management</h6>
            <p>Cable Ladders, Cable Trays, Cable Trunking, Rigid Conduit, Flexible Conduits, Metal Framing, GI Back Box, Conduit Boxes & EYS Conduit Seals</p>
          </div>
        </div>
      </div>
    </Link>

    <Link to='/PowerInstrumentation'>
      <div className='product-card'>
        <img src="assets/apip2.png" alt="" />
        <div className='text-product'>
          <div>
            <h6>Cables</h6>
            <p>Power, Instrumentation, Control, Thermocouple, Fiber Optics, Telecommunication & Data</p>
          </div>
        </div>
      </div>
    </Link>

    

    
    

    <Link to='/Cableties'>
      <div className='product-card'>
        <img src="/assets/inground1.png" alt="" />
        <div className='text-product'>
          <div>
            <h6>In-Ground Power Supply Units</h6>
            <p>Multiple-load Category & Output(s) - Power, Water, Compressed Air, Video, Audi & Data</p>
          </div>
        </div>
      </div>
    </Link>

    <Link to='/HeatShrink'>
      <div className='product-card'>
        <img src="/assets/saigel.png" alt="" />
        <div className='text-product'>
          <div>
            <h6>Electrical Bulk - Oil & Gas</h6>
            <p>Lighting Fixtures, Lighting Poles, Cables, Cable Glands, Cable Cleats, Local Control Stations, Junction Boxes, Sockets & Switches, Isolators, Push Buttons, Earthing & Lightning Materials, Cable Trays & Ladders, Cable Accessories, Conduits, Cable Route Markers, Cable Tiles, Warning Tapes, Fixing & Supports</p>
          </div>
        </div>
      </div>
    </Link>

    <Link to='/InstrumentationBulk'>
      <div className='product-card'>
        <img src="/assets/saigin.png" alt="" />
        <div className='text-product'>
          <div>
            <h6>Instrumentation Bulk - Oil & Gas</h6>
            <p>Instrumentation & Control Cables, Thermocouple Cables, Cable Glands, Cable Lugs & Terminals, Instrumentation Tubing & Tube Fittings, Tube Clamps, Valves & Manifolds, Junction Box, Sunshades, Stanchion & Multi Cable Transit System</p>
          </div>
        </div>
      </div>
    </Link>

  </div>
</div>


        </div>
      </div>
    </>
  )
}

export default Product